import { LoggerService } from '../../logging/services/logger.service.js';
/**
 * 学习服务
 * 处理与学习记录相关的操作，如保存笔记、单词卡等
 *
 * 核心功能：
 * 1. 提供学习笔记的保存和管理能力
 * 2. 处理多语言的学习记录数据
 * 3. 支持语法分析和上下文释义的存储
 * 4. 关联学习内容与源文档
 * 5. 为未来的云端存储和多设备同步做准备
 */
// Implement the interface and make it a singleton
export class LearningService {
    constructor() {
        this.logger = LoggerService.getInstance().createDomainLogger('LEARNING');
        // Private constructor for singleton
    }
    static getInstance() {
        if (!LearningService.instance) {
            LearningService.instance = new LearningService();
        }
        return LearningService.instance;
    }
    /**
     * 保存学习笔记
     * @param note 学习笔记对象 (不含 id 和 createdAt)
     * @returns 保存操作的结果或保存后的笔记对象
     */
    // Remove static, adjust parameter type to match interface
    async saveNote(note) {
        // --- 未来实现 ---
        // 1. 调用 Supabase API 将笔记存入数据库
        // const { data, error } = await supabase
        //   .from('learning_notes') // 假设表名为 learning_notes
        //   .insert([
        //     {
        //       original_text: note.originalText,
        //       translated_text: note.translatedText,
        //       source_language: note.sourceLanguage,
        //       target_language: note.targetLanguage,
        //       grammar_analysis: note.grammarAnalysis,
        //       context_analysis: note.contextAnalysis,
        //       style_analysis: note.styleAnalysis,
        //       // user_id: userId, // 获取当前用户 ID
        //     },
        //   ])
        //   .select(); // 返回插入的数据
        // if (error) {
        //   this.logger.error('保存笔记失败', { error });
        //   return { error: error.message };
        // }
        // return data ? data[0] : { error: '未能获取保存后的笔记' };
        // --- 结束 未来实现 ---
        // 模拟成功返回
        // 模拟 API 延迟
        await new Promise(resolve => setTimeout(resolve, 1000));
        // Construct the full note including new id and timestamp
        const savedNote = {
            ...note,
            id: `mock-${Date.now()}`,
            createdAt: new Date(),
        };
        return savedNote;
    }
}
LearningService.instance = null;
//# sourceMappingURL=learning.service.js.map